import { useState, useEffect, useRef } from 'react';
import { generateCommentsForNews } from '../data/comments';

export default function usePhoneSystem(phoneData, activeApp, state, onPhoneAction) {
  const [detail, setDetail] = useState(null);
  const [newsTab, setNewsTab] = useState('today');
  const [inputText, setInputText] = useState("");
  const [chatLog, setChatLog] = useState({});
  const [commentLog, setCommentLog] = useState({});
  const [answered, setAnswered] = useState({});
  const [isTyping, setIsTyping] = useState(false);
  const [newsComments, setNewsComments] = useState({});
  const [readItems, setReadItems] = useState({});
  const chatEndRef = useRef(null);

  const handleOpenDetail = (appType, itemData, isHistory = false) => {
    setDetail({ type: appType, data: itemData, isHistory });
  };

  // 1. 已读上报逻辑
  useEffect(() => {
    if (!detail || detail.isHistory) return;
    let markCount = 0;
    const newReadItems = { ...readItems };
    let needsReply = false;

    if (detail.type === 'sms') {
      const senderMsgs = phoneData.sms.filter(m => m.sender === detail.data.sender);
      senderMsgs.forEach(msg => {
        const uid = `sms_${msg.id}`;
        if (!newReadItems[uid]) { newReadItems[uid] = true; markCount++; }
        if (msg.choices && msg.choices.length > 0 && !answered[msg.id]) needsReply = true;
      });
    } else {
      const uid = `${detail.type}_${detail.data.id}`;
      if (!newReadItems[uid]) { newReadItems[uid] = true; markCount++; }
    }

    if (markCount > 0) {
      setReadItems(newReadItems);
      if (onPhoneAction) {
        onPhoneAction({ actionType: 'MARK_AS_READ', app: detail.type, count: markCount, sender: detail.type === 'sms' ? detail.data.sender : null, unblock: !needsReply });
      }
    }
  }, [detail, phoneData, readItems, answered, onPhoneAction]);

  // 2. 新闻水军评论生成
  useEffect(() => {
    if (detail && detail.type === 'news') {
      const newsId = detail.data.id;
      if (!newsComments[newsId]) {
        setNewsComments(prev => ({ ...prev, [newsId]: generateCommentsForNews(detail.data.title || "") }));
      }
    }
  }, [detail, newsComments]);

  // 3. 切换App重置详情页
  useEffect(() => { setDetail(null); setInputText(""); }, [activeApp]);

  // 4. 自动滚动到底部
  useEffect(() => {
    if (chatEndRef.current) chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [detail, chatLog, commentLog, isTyping]);

  const handleChoice = (choice, targetId, senderOrNewsId, type) => {
    setAnswered(prev => ({ ...prev, [targetId]: true }));
    const userMsg = { id: Date.now(), text: choice.text, isUser: true, author: '我', replyTo: targetId };

    if (type === 'sms') setChatLog(prev => ({ ...prev, [senderOrNewsId]: [...(prev[senderOrNewsId] || []), userMsg] }));
    else setCommentLog(prev => ({ ...prev, [senderOrNewsId]: [...(prev[senderOrNewsId] || []), userMsg] }));

    if (onPhoneAction) {
      if (choice.effect) onPhoneAction(choice.effect);
      if (type === 'sms') onPhoneAction({ actionType: 'REPLY_SMS', sender: senderOrNewsId });
    }

    if (type === 'sms' && choice.nextReply) {
      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        setChatLog(prev => ({ ...prev, [senderOrNewsId]: [...(prev[senderOrNewsId] || []), { id: Date.now() + 1, text: choice.nextReply, isUser: false, replyTo: targetId }] }));
      }, 1500);
    }
  };

  const handleTrade = (key, price, action) => {
    if (action === 'buy') {
      const cost = price * 100;
      if (state.money >= cost) onPhoneAction({ actionType: 'TRADE_STOCK', stockKey: key, amount: 100, totalCost: cost });
      else alert("穷鬼，余额不足以买入一手（100股）！");
    } else if (action === 'sell') {
      const hold = state.portfolio[key] || 0;
      if (hold > 0) onPhoneAction({ actionType: 'TRADE_STOCK', stockKey: key, amount: -hold, totalCost: -(price * hold) });
    }
  };

  const getLastMessageText = (sender) => {
    const senderMsgs = phoneData.sms.filter(m => m.sender === sender).reverse();
    const myReplies = chatLog[sender] || [];
    let lastText = "";
    senderMsgs.forEach(msg => {
      lastText = msg.text;
      const relatedReplies = myReplies.filter(reply => reply.replyTo === msg.id);
      if (relatedReplies.length > 0) lastText = relatedReplies[relatedReplies.length - 1].text;
    });
    return lastText;
  };

  // 拼接供详情页渲染的消息流
  let displayMessages = [];
  if (detail && detail.type === 'sms') {
    const senderMsgs = phoneData.sms.filter(m => m.sender === detail.data.sender).reverse();
    const myReplies = chatLog[detail.data.sender] || [];
    senderMsgs.forEach(msg => {
      displayMessages.push({ ...msg, isUser: false });
      const relatedReplies = myReplies.filter(reply => reply.replyTo === msg.id);
      if (relatedReplies.length > 0) displayMessages.push(...relatedReplies);
    });
  }

  return {
    detail, setDetail, newsTab, setNewsTab, inputText, setInputText,
    isTyping, newsComments, commentLog, answered, chatEndRef, displayMessages,
    handleOpenDetail, handleChoice, handleTrade, getLastMessageText
  };
}